import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { userLoginPhoneSchema } from 'validation';
import { processEvent } from 'lib/eventsHandler';


import Image from 'next/image';
import { OTPForm } from './pages/auth';
import { signIn, useSession } from 'next-auth/react';
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useApiMutation } from 'hooks/useApi';
import axiosInstance from 'helper/apis/axiosInstance';

const DialogAuth = ({ open, setOpen }) => {
  // const handleOverlayClick = (e) => {
  //   // Prevent modal from closing when clicking outside the content
  //   e.stopPropagation();
  // };
  const router = useRouter();
  const { data: session } = useSession();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [step, setStep] = useState("phone"); // phone | otp
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: zodResolver(userLoginPhoneSchema),
    defaultValues: {
      phone: "",
    },
  });
  const { executeMutation, isMutating } = useApiMutation("/consultation");


  const handleSubmitWithPayload = async (payload) => {
    const response = await executeMutation("POST", payload);

    const res = await axiosInstance.post(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}payment/paymentLink/${response?._id}`,
      { type: "consultation" }
    );

    const user = session?.user;
    processEvent({
      event: 'webapp_schedule',
      event_status: 'success',
      phone: user?.phone,
      id: user?.id,
      full_name: user?.full_name,
      role: user?.role,
      method: 'phone',
      isActive: user?.isActive,
      status: user?.status
    });

    window.location.href = res?.data?.paymentLink;
    toast.success("تم الحجز يرجي تكملة عملية الدفع");
    localStorage.removeItem("selectedSchedule");
  };

  const handlePhoneChange = (value) => {
    setPhoneNumber(value);
    setValue('phone', value);
  };

  

  const onSubmit = (data) => {
    // Validate phone
    if (!data.phone) return;
    // Send tracking if needed
    // processEvent({ event: "phone_submitted", phone: data.phone, event_status: "submitted" });
    setStep("otp");
  };

  return (
    <>
      {open && (
        <div
          className="fixed top-0 right-0 left-0 z-[999] flex justify-center items-center w-full h-[calc(100%-1rem)] overflow-y-auto overflow-x-hidden md:inset-0 max-h-full bg-black bg-opacity-50"

        >
          {/* Modal Container */}
          <div
            // Handle keyboard interaction
            role="button" // Add appropriate role
            tabIndex={0} // Make the element focusable
            className="relative md:p-4 px-2 w-full max-w-xl max-h-full"
          >
            {/* Modal Content */}
            <div className="relative bg-white dark:bg-gray-700 rounded-lg shadow-md max-sm:h-[90vh] max-sm:overflow-y-auto">
              {/* Modal Header */}
              <div className='bg-gray-100 dark:bg-gray-800 px-2 md:p-4 pb-0 flex justify-between items-center'>
                <button
                  onClick={() => setOpen(false)}
                  type="button"
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-xl w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white "
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 1l6 6m0 0l6 6M7 7l6-6M7 7L1 13"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
                {step === "otp" && (
                  <button onClick={() => setStep("phone")} className="p-2">
                    <IoMdArrowRoundBack className='text-2xl' />
                  </button>
                )}
              </div>

              <div className="flex items-center justify-center p-2 md:p-5 border-b border-gray-200 dark:border-gray-600 rounded-t bg-gray-100 dark:bg-gray-800">

                <div className=" text-center md:pt-6">
                  <Image src="/tqneen/brand.svg" width={100} height={100} alt="Brand" />
                  <p className="text-center text-xl">تسجيل الدخول</p>
                </div>

              </div>

              {/* Modal Body */}
              <div className="p-4 md:p-5 bg-gray-50 dark:bg-gray-900">
                {step === "phone" ?
                  <form onSubmit={handleSubmit(onSubmit)} className="relative space-y-2">
                    <label htmlFor="phone-input" className="block text-sm font-medium text-gray-700 mb-2">
                      رقم الهاتف <span className="text-red-500">*</span>
                    </label>
                    <PhoneInput
                      id="phone-input"
                      international
                      country="eg"
                      maxLength={15}
                      inputStyle={{
                        border: "none",
                        width: "100%"
                      }}
                      value={phoneNumber}
                      enableAreaCodes={true}
                      onChange={handlePhoneChange}
                      dir="ltr"
                      containerClass="w-full flex-row-reverse py-2 border rounded-lg focus:ring-2 focus:ring-customer-primary focus:border-customer-primary [&>input]:text-left [&>input]:border-none [&>input]:outline-none [&>input]:ring-0 [&>input]:pr-10 [&>input]:pl-2 "
                      containerStyle={{
                        direction: 'ltr',
                      }}
                      labels={{ phone: "رقم الهاتف" }}
                    />
                    {(errors.phone) && (
                      <p className="mt-1 text-sm text-red-500">{errors.phone?.message}</p>
                    )}
                    <div className="py-4 flex items-center justify-center">
                      <button
                        type="submit"
                        className="text-white bg-primary-button  hover:bg-primary-button-hover focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg px-10 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 text-md"
                      >
                        تسجيل الدخول
                      </button>
                    </div>
                  </form>
                  : (
                    <OTPForm
                      phoneNumber={phoneNumber}
                      onSuccess={async ({ token, user }) => {
                        // // Success: close modal or go to next step
                        try {
                          const result = await signIn("credentials", {
                            redirect: false,
                            user: JSON.stringify({ token, user }),
                          });

                          if (result.error) throw new Error(result.error);
                          const storedPayload = localStorage.getItem("pendingConsultation");

                          if (storedPayload) {
                            const payload = JSON.parse(storedPayload);
                            localStorage.removeItem("pendingConsultation");

                            await handleSubmitWithPayload(payload); // 👈 execute payload
                          } else {
                            router.reload();
                          }
                          setOpen(false);
                        } catch (error) {
                          toast.error(error?.message || "حدث خطأ ما أثناء تسجيل الدخول");
                        }
                      }}
                    />
                  )}
              </div>

              {/* Modal Footer */}

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DialogAuth;